import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { recognizeItems } from '../data/musikkklar';
export function Recognize() {
  return <section className="w-full bg-slate-900 px-8 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-267" data-mp="30xq4xbz16gtq">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-268" data-mp="2w56qkcsirhnv">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-5" data-id="element-269" data-mp="2r7wrs6j8ptnd">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-270" data-mp="2m8bue0jpxtcr">
            Har du noen gang opplevd dette?
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-271" data-mp="2i5xenpbcj9pp">
            Hvis du svarer ja på minst ett spørsmål, er MUSIKK KLAR™ for deg.
          </p>
          <a href="#inside" className="group mt-10 inline-flex items-center gap-2 font-serif text-2xl italic text-red-300 transition-colors duration-150 ease-out hover:text-stone-50" data-id="element-272" data-mp="289c6iv415ihn">
            Du fortjener en enklere måte
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-273" data-mp="6ih77tam7166" />
          </a>
        </div>

        <ul className="divide-y divide-white/10 border-y border-white/10 lg:col-span-7" data-id="element-274" data-mp="3nn6y5yn9dsbq">
          {recognizeItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex gap-5 py-7 sm:gap-6" data-id="element-275" data-mp="39p8ylzdlk0ga">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 text-red-300" data-id="element-276" data-mp="3em93w82mgz6c">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-277" data-mp="b5acte0rkaid" />
                </span>
                <div data-id="element-278" data-mp="b73ba6183ofa">
                  <h3 className="font-serif text-2xl leading-tight sm:text-3xl" data-id="element-279" data-mp="3sma4dmez64la">{item.title}</h3>
                  <p className="mt-2 leading-relaxed text-stone-50/70" data-id="element-280" data-mp="1f7a2m3ubi6u">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}